<template>
  <div class="fill-height">
    <div
      class="d-flex justify-center align-center grey lighten-5 fill-width py-3"
    >
      <researcher-avatar-cluster
        class="mr-2"
        :researchers="researchers"
      />
      <span class="text-body-2">
        <researcher-inline-list :researchers="researchers" />
        voted
      </span>
    </div>
    <v-divider />
  </div>
</template>

<script>
import ResearcherAvatarCluster from '@/components/Common/ResearcherAvatarCluster';
import ResearcherInlineList from '@/components/Common/ResearcherInlineList';
import { Researcher } from '@/models';
import { typeHelpers } from '@/modules';

export default {
  name: 'VoteStatusBar',
  components: { ResearcherAvatarCluster, ResearcherInlineList },
  props: {
    researchers: {
      type: Array,
      default: () => [],
      validator: (item) =>
        typeHelpers.isArrayOfType(item, Researcher),
    },
  },
};
</script>

<style lang="scss" scoped>
.fill-width {
  width: 100%;
}
</style>
